import { updateObject } from '../../helpers/utility.helper';
import IDownloadFile from '../models/IDownloadFile';
import { initialState } from '../state/downloadFile.state';
import fileType from '../types/downloadFile.type';

const getAllFileStart = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        fileList: updateObject(oldState.fileList, {
            error: null, loading: true
        })
    });
};

const getAllFileSuccess = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        fileList: updateObject(oldState.fileList, {
            files: action.payload,
            error: null,
            loading: false
        })
    });
};

const getAllFileError = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        fileList: updateObject(oldState.fileList, {
            error: action.payload,
            loading: false
        })
    });
};

const filePreparationStart = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        filePreparation: updateObject(oldState.filePreparation, {
            error: null, loading: true
        })
    });
};

const filePreparationSuccess = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        filePreparation: updateObject(oldState.filePreparation, {
            success:true,
            error: null,
            loading: false  
        })
    });
};

const filePreparationError = (oldState: IDownloadFile, action: any) => {
    return updateObject(oldState, {
        filePreparation: updateObject(oldState.filePreparation, {
            error: action.payload,
            loading: false
        })
    });
};

const resetFilePreparationState = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        filePreparation:initialState.filePreparation
    });
};

const deleteFileStart = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteFile:updateObject(oldState.deleteFile, {
        loading: true
        })
    });
};

const deleteFileSuccess = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteFile:updateObject(oldState.deleteFile, {
        success:true,
        error: null,
	    loading: false        
        })
    });
};

const deleteFileError = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteFile:updateObject(oldState.deleteFile, {
        success:false,
        error: action.payload,
	    loading: false
        })
    });
};

const resetDeleteFileState = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteFile:initialState.deleteFile
    });
};

const deleteSelectedFileStart = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteSelectedFile:updateObject(oldState.deleteSelectedFile, {
        loading: true
        })
    });
};

const deleteSelectedFileSuccess = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteSelectedFile:updateObject(oldState.deleteSelectedFile, {
        success:true,
        error: null,
	    loading: false        
        })
    });
};

const deleteSelectedFileError = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteSelectedFile:updateObject(oldState.deleteSelectedFile, {
        success:false,
        error: action.payload,
	    loading: false
        })
    });
};

const resetDeleteSelectedFileState = (oldState:IDownloadFile, action: any) => {
	return updateObject(oldState, {
        deleteSelectedFile:initialState.deleteSelectedFile
    });
};

const downloadFileReducer = (oldState: IDownloadFile = initialState, action: any) => {
    switch (action.type) {
        case fileType.GET_ALL_FILE_START: return getAllFileStart(oldState, action);
        case fileType.GET_ALL_FILE_SUCCESS: return getAllFileSuccess(oldState, action);
        case fileType.GET_ALL_FILE_ERROR: return getAllFileError(oldState, action);
        case fileType.FILE_PREPARATION_START: return filePreparationStart(oldState, action);
        case fileType.FILE_PREPARATION_SUCCESS: return filePreparationSuccess(oldState, action);
        case fileType.FILE_PREPARATION_ERROR: return filePreparationError(oldState, action);
        case fileType.RESET_FILE_PREPARATION_STATE: return resetFilePreparationState(oldState, action);
        case fileType.DELETE_FILE_START: return deleteFileStart(oldState, action);
        case fileType.DELETE_FILE_SUCCESS: return deleteFileSuccess(oldState, action);
        case fileType.DELETE_FILE_ERROR: return deleteFileError(oldState, action);
        case fileType.RESET_DELETE_FILE_STATE: return resetDeleteFileState(oldState, action);

        case fileType.DELETE_SELECTED_FILE_START: return deleteSelectedFileStart(oldState, action);
        case fileType.DELETE_SELECTED_FILE_SUCCESS: return deleteSelectedFileSuccess(oldState, action);
        case fileType.DELETE_SELECTED_FILE_ERROR: return deleteSelectedFileError(oldState, action);
        case fileType.RESET_DELETE_SELECTED_FILE_STATE: return resetDeleteSelectedFileState(oldState, action);

        default: return oldState;
    }
};
export default downloadFileReducer;